"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conditionalAttributes = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
* conditionaAttributes is a utillity method that is used to overcome the
* issue that react now has with es6 transforms and spreading attributes.
* @param {*} config
* @returns {Object} - An object containing only the attributes that satisfy the condition (non-null and non-undefined).
*/
const conditionalAttributes = function (conditions) {
  // Handle non-object inputs
  if (!conditions || typeof conditions !== 'object') {
    return {};
  }
  return Object.keys(conditions).reduce((acc, key) => {
    const condition = conditions[key];
    // only return attributes if they don't evaluate to undefined or null
    if (condition !== undefined && condition !== null) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [key]: condition
      });
    }
    return acc;
  }, {});
};
exports.conditionalAttributes = conditionalAttributes;